import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getDaDataSuggestParty, GetDaDataSuggestRequest } from "../api";

export function useDaDataSuggestion(request: GetDaDataSuggestRequest) {
  return useQuery({
    queryFn: () => getDaDataSuggestParty(request),
    queryKey: ["dadata", "suggest", "party", request],
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
}
